import { TextCodes } from '@api/types/translation/TextCodes';
import { Title } from '@components';
import { Stack } from '@mui/material';
import { t } from '@translations';
import { ReactNode } from 'react';

export type OrderPageHeaderProps = {
  title?: string;
  children?: ReactNode;
};

export const OrderPageHeader = ({ title, children }: OrderPageHeaderProps) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      flexWrap='wrap'
      sx={{ mb: 4 }}
    >
      <Title variant='h2'>{title || t(TextCodes.Order.Block.Orders)}</Title>
      {children}
    </Stack>
  );
};
